{
  "version": 2,
  "packages": [
    {
      "id": "starter_monthly",
      "planName": "Starter",
      "name": "Starter",
      "credits": 100,
      "price": 3,
      "originalPrice": null,
      "discount": 0,
      "pricePerMonth": null,
      "savings": null,
      "description": "Perfect for getting started",
      "type": "subscription",
      "billingPeriod": "monthly",
      "popular": false,
      "visible": true,
      "productId": "pro_01jyhtgnp10zk2wy22cehyq57a",
      "priceId": "pri_01jyhtnzvz4zv5tcks1wa5kkhe",
      "checkoutDiscountId": null,
      "features": [
        "100 credits/month",
        "AI metadata generation",
        "Basic support"
      ],
      "icon": "🚀",
      "sortOrder": 10
    },
    {
      "id": "growth_monthly",
      "planName": "Growth",
      "name": "Growth",
      "credits": 1000,
      "price": 9,
      "originalPrice": null,
      "discount": 0,
      "pricePerMonth": null,
      "savings": null,
      "description": "Grow your portfolio",
      "type": "subscription",
      "billingPeriod": "monthly",
      "popular": false,
      "visible": true,
      "productId": "pro_01jyhtr9bgsaxx3xfqfdwr1gze",
      "priceId": "pri_01jyhtv3h1etmf3ya2ks3d8ps0",
      "checkoutDiscountId": null,
      "features": [
        "1,000 credits/month",
        "AI metadata generation",
        "Priority support",
        "Bulk processing"
      ],
      "icon": "📈",
      "sortOrder": 20
    },
    {
      "id": "pro_monthly",
      "planName": "Pro",
      "name": "Pro",
      "credits": 2000,
      "price": 17,
      "originalPrice": null,
      "discount": 0,
      "pricePerMonth": null,
      "savings": null,
      "description": "For consistent high-volume work",
      "type": "subscription",
      "billingPeriod": "monthly",
      "popular": false,
      "visible": true,
      "productId": "pro_01jyhv1g5ctksq8qp1r3syvp3t",
      "priceId": "pri_01jyhv3342331am37vawkrtqa6",
      "checkoutDiscountId": null,
      "features": [
        "2,000 credits/month",
        "AI metadata generation",
        "Priority support",
        "Bulk processing",
        "Advanced features"
      ],
      "icon": "🎯",
      "sortOrder": 30
    },
    {
      "id": "agency_monthly",
      "planName": "Agency",
      "name": "Agency",
      "credits": 5000,
      "price": 36,
      "originalPrice": null,
      "discount": 0,
      "pricePerMonth": null,
      "savings": null,
      "description": "For high-volume production workflows",
      "type": "subscription",
      "billingPeriod": "monthly",
      "popular": false,
      "visible": true,
      "productId": "pro_01jyhv6v3fv9gyzt2xe2fbzq0e",
      "priceId": "pri_01jyhv873jgz6d03zc9h9pf1b8",
      "checkoutDiscountId": null,
      "features": [
        "5,000 credits/month",
        "AI metadata generation",
        "Premium support",
        "Bulk processing",
        "Advanced features"
      ],
      "icon": "🏢",
      "sortOrder": 40
    },
    {
      "id": "scale_monthly",
      "planName": "Scale",
      "name": "Scale",
      "credits": 10000,
      "price": 64,
      "originalPrice": null,
      "discount": 0,
      "pricePerMonth": null,
      "savings": null,
      "description": "For maximum monthly production volume",
      "type": "subscription",
      "billingPeriod": "monthly",
      "popular": false,
      "visible": true,
      "productId": "pro_01m12t8ww96pfx7nr4ktkcqq37",
      "priceId": "pri_01m12t8x2vsa6psqj560bjh45e",
      "checkoutDiscountId": null,
      "features": [
        "10,000 credits/month",
        "AI metadata generation",
        "Premium support",
        "Bulk processing",
        "Advanced features"
      ],
      "icon": "⚡",
      "sortOrder": 50
    },
    {
      "id": "byok_monthly",
      "planName": "BYOK",
      "name": "Unlimited BYOK",
      "credits": -1,
      "price": 6,
      "originalPrice": null,
      "discount": 0,
      "pricePerMonth": null,
      "savings": null,
      "description": "Unlimited with your own API keys",
      "type": "byok",
      "billingPeriod": "monthly",
      "popular": false,
      "visible": false,
      "productId": "pro_01jypexzshpcv6h6y0xejaxtpt",
      "priceId": "pri_01jypf0fe8dy8kzxf7ezrq6ddn",
      "checkoutDiscountId": null,
      "features": [
        "Unlimited metadata generation",
        "No daily caps",
        "Use OpenAI, Gemini, Claude, Groq, Grok",
        "Multi-key rotation + failover",
        "Fastest throughput",
        "Priority support",
        "Full cost control"
      ],
      "icon": "🔑",
      "sortOrder": 60
    },
    {
      "id": "starter_yearly",
      "planName": "Starter",
      "name": "Starter",
      "credits": 100,
      "price": 27,
      "originalPrice": 36,
      "discount": 25,
      "pricePerMonth": 2.25,
      "savings": 9,
      "description": "Perfect for getting started",
      "type": "subscription",
      "billingPeriod": "yearly",
      "popular": false,
      "visible": true,
      "productId": "pro_01kbyveyz5w3rcrjeebqtfsg5j",
      "priceId": "pri_01kbyvk8cq59r9qpjtx0nrqtp5",
      "checkoutDiscountId": "dsc_01kbyvmqq10fvnc7t7h653a2hy",
      "features": [
        "100 credits/month",
        "AI metadata generation",
        "Basic support",
        "Annual savings included"
      ],
      "icon": "🚀",
      "sortOrder": 70
    },
    {
      "id": "growth_yearly",
      "planName": "Growth",
      "name": "Growth",
      "credits": 1000,
      "price": 81,
      "originalPrice": 108,
      "discount": 25,
      "pricePerMonth": 6.75,
      "savings": 27,
      "description": "Grow your portfolio",
      "type": "subscription",
      "billingPeriod": "yearly",
      "popular": false,
      "visible": true,
      "productId": "pro_01kbyvtzby5fae82bwc9r451cn",
      "priceId": "pri_01kbyvxeyta8y2f52hqh9t92m0",
      "checkoutDiscountId": "dsc_01kbyvmqq10fvnc7t7h653a2hy",
      "features": [
        "1,000 credits/month",
        "AI metadata generation",
        "Priority support",
        "Bulk processing",
        "Annual savings included"
      ],
      "icon": "📈",
      "sortOrder": 80
    },
    {
      "id": "pro_yearly",
      "planName": "Pro",
      "name": "Pro",
      "credits": 2000,
      "price": 153,
      "originalPrice": 204,
      "discount": 25,
      "pricePerMonth": 12.75,
      "savings": 51,
      "description": "For consistent high-volume work",
      "type": "subscription",
      "billingPeriod": "yearly",
      "popular": false,
      "visible": true,
      "productId": "pro_01kbyvzsfe90mntgyy161eq1xt",
      "priceId": "pri_01kbyw37xb8kgx86b2fr58gvy4",
      "checkoutDiscountId": "dsc_01kbyvmqq10fvnc7t7h653a2hy",
      "features": [
        "2,000 credits/month",
        "AI metadata generation",
        "Priority support",
        "Bulk processing",
        "Advanced features",
        "Annual savings included"
      ],
      "icon": "🎯",
      "sortOrder": 90
    },
    {
      "id": "agency_yearly",
      "planName": "Agency",
      "name": "Agency",
      "credits": 5000,
      "price": 324,
      "originalPrice": 432,
      "discount": 25,
      "pricePerMonth": 27,
      "savings": 108,
      "description": "For high-volume production workflows",
      "type": "subscription",
      "billingPeriod": "yearly",
      "popular": false,
      "visible": true,
      "productId": "pro_01kbyw6gmfj507cw0w9aesmjfa",
      "priceId": "pri_01kbyw9fcz12atrppqyr3ebh4j",
      "checkoutDiscountId": "dsc_01kbyvmqq10fvnc7t7h653a2hy",
      "features": [
        "5,000 credits/month",
        "AI metadata generation",
        "Premium support",
        "Bulk processing",
        "Advanced features",
        "Annual savings included"
      ],
      "icon": "🏢",
      "sortOrder": 100
    },
    {
      "id": "scale_yearly",
      "planName": "Scale",
      "name": "Scale",
      "credits": 10000,
      "price": 576,
      "originalPrice": 768,
      "discount": 25,
      "pricePerMonth": 48,
      "savings": 192,
      "description": "For maximum monthly production volume",
      "type": "subscription",
      "billingPeriod": "yearly",
      "popular": false,
      "visible": true,
      "productId": "pro_01m12t8xa37xbe0xctdzjejqat",
      "priceId": "pri_01m12t8xffqc17wwc8vpx2f412",
      "checkoutDiscountId": "dsc_01kbyvmqq10fvnc7t7h653a2hy",
      "features": [
        "10,000 credits/month",
        "AI metadata generation",
        "Premium support",
        "Bulk processing",
        "Advanced features",
        "Annual savings included"
      ],
      "icon": "⚡",
      "sortOrder": 110
    },
    {
      "id": "byok_yearly",
      "planName": "BYOK",
      "name": "Unlimited BYOK",
      "credits": -1,
      "price": 36,
      "originalPrice": 72,
      "discount": 50,
      "pricePerMonth": 3,
      "savings": 36,
      "description": "Unlimited with your own API keys",
      "type": "byok",
      "billingPeriod": "yearly",
      "trialDays": 1,
      "popular": false,
      "visible": false,
      "productId": "pro_01kbywgh99p98p4er4ehvfdgnt",
      "priceId": "pri_01kbywhjk1a3dbfakq57cr4af3",
      "checkoutDiscountId": null,
      "features": [
        "Unlimited metadata generation",
        "No daily caps",
        "Use OpenAI, Gemini, Claude, Groq, Grok",
        "Multi-key rotation + failover",
        "Fastest throughput",
        "Priority support",
        "Full cost control"
      ],
      "icon": "🔑",
      "sortOrder": 120
    },
    {
      "id": "additional_credits",
      "planName": "Additional Credits",
      "name": "Additional Credits",
      "credits": 500,
      "price": 5,
      "originalPrice": null,
      "discount": 0,
      "pricePerMonth": null,
      "savings": null,
      "description": "One-time credit pack",
      "type": "one-time",
      "billingPeriod": "one-time",
      "popular": false,
      "visible": true,
      "productId": "pro_01jypf47ynmatfgrw0mfz4bjk1",
      "priceId": "pri_01jypf5qt0sxnd9pfanp9782st",
      "checkoutDiscountId": null,
      "features": [
        "500 additional credits",
        "One-time purchase",
        "Stacks on top of subscription credits"
      ],
      "icon": "⚡",
      "sortOrder": 130
    }
  ]
}
